import React from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from "../../store/actions/index";
import classes from '../../components/profile/profile.module.css';
import MyAccount from '../../components/profile/myAccount/myAccount';
import MyActivities from '../../components/profile/myActivities/myActivities';
import SignedDocuments from '../../components/profile/signedDocuments/signedDocuments';
import ChangePassword from '../../components/profile/changePassword/changePassword';

const Login = (props) => {
    const { slug } = useParams();
    const Header = (props) => {
        return (
            <div className={classes.Header}>
                <div><span>Profile / </span>{props.Title}</div>
                <h1>{props.Title}</h1>
            </div>
        )
    }
    return (
        <div className={classes.Container}>
            {slug === 'account' &&
                <div className={classes.MyAccount}>
                    <Header Title='My Account' />
                    <MyAccount userData={props.userData}/>
                </div>
            }
            {slug === 'activities' &&
                <div className={classes.MyActivities}>
                    <Header Title='My Activities' />
                    <MyActivities />
                </div>
            }
            {slug === 'signed-documents' &&
                <div className={classes.SignedDocuments}>
                    <Header Title='Signed Document' />
                    <SignedDocuments />
                </div>
            }
            {slug === 'change-password' &&
                <div className={classes.ChangePassword}>
                    <Header Title='Change Password' />
                    <ChangePassword onChangePassword={props.onChangePassword} message={props.success_message} errorMessage={props.error}/>
                </div>
            }
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        onChangePassword: (token, email, current_password, new_password, new_password_confirmation) =>
            dispatch(actions.changePassword(token, email, current_password, new_password, new_password_confirmation)),
    };
};
const mapStateToProps = state => ({
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    token: state.auth.token,
    user: state.auth.user,
    userData: state.profile.userProfile,
    language: state.home.selected_language === 1 ? "en" : "ar",
    success_message: state.auth.message,
});
export default connect(mapStateToProps, mapDispatchToProps)(Login);